import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Textarea } from '@/shared/ui';

import styles from './ConclusionInfoRow.module.scss';

interface ConclusionInfoRowProps {
  label: string;
  value: string;
  isEditMode?: boolean;
  isTitle?: boolean;
  isSpan?: boolean;
  isPreview?: boolean;
  isReadOnly?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
}

export const ConclusionInfoRow: FC<ConclusionInfoRowProps> = ({
  label,
  value,
  isEditMode = false,
  isTitle = false,
  isSpan = false,
  isPreview = false,
  isReadOnly = false,
  onChange,
  className,
}) => {
  const { formatMessage } = useIntl();

  const isEditable = typeof onChange === 'function' && !isReadOnly;
  const resultValue =
    value ||
    formatMessage({
      id: 'report.extendedConclusion.notSpecified',
      defaultMessage: 'not specified',
    });

  return (
    <div
      className={cn(
        styles.container,
        isSpan && styles.span,
        isPreview && styles.preview,
        className,
      )}
    >
      <div
        className={cn(
          styles.label,
          isTitle && styles.title,
          isPreview && styles.previewLabel,
        )}
      >
        {label}:
      </div>
      {isEditable && isEditMode ? (
        <Textarea
          rows={1}
          isElastic={true}
          value={value}
          onChange={onChange}
          className={cn(styles.input, styles.elastic)}
        />
      ) : (
        <div className={styles.value}>{resultValue}</div>
      )}
    </div>
  );
};
